// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";

function toRadians(a) {
  return a / (180 / Math.PI);
}

let jsonCodec = Jzon.float;

export {
  toRadians,
  jsonCodec,
}
/* No side effect */
